/* global axios */
import ApiClient from './ApiClient';

class CortexModelRoutesAPI extends ApiClient {
  constructor() {
    super('cortex/model_routes', { accountScoped: true });
  }

  applyProfile(data) {
    return axios.post(`${this.url}/apply_profile`, data);
  }
}

export default new CortexModelRoutesAPI();
